const INVOICE_STATUS = Object.freeze({
  overdue: 'overdue',
  paid: 'paid',
  open: 'open',
  refunded: 'Refunded',
  void: 'void',
  partiallyRefunded: 'Partially Refunded',
});

// noinspection JSUnusedGlobalSymbols
export default INVOICE_STATUS;
